/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from "react";
import { Box, Typography, FormGroup, FormControlLabel, Radio, RadioGroup, TextField, Autocomplete, Chip } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import {theme, OptionsWrapper} from "../Styles/Languages";
import InputAdornment from "@mui/material/InputAdornment";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import en from '../../nls/en.json';
import { useSelector } from "react-redux";
import { getLanguages } from "../../store/studentSlice";
import { useDispatch } from "react-redux";
import { isEmpty, checkDuplicateChipValue } from "../../utils/constants";
import { useLocation } from "react-router-dom";
import styled from "@emotion/styled";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

const ChipWrapper = styled.div`
  display: flex;
  flex-wrap:wrap;
  flex-direction: row;
  gap: 8px;
  padding: 12px 24px;
  border: solid 1px #1468a2;
  border-radius: 8px;
  min-height: 96px;
  align-content: flex-start;
  .MuiChip-root{
    background-color:#C6E3F9;
    border:solid 1px #44A4EB;
    border-radius:4px;
    @media(max-width:767px){
      max-width:240px
    }
    svg{
      fill:#1468A2;
    }
  }
`;

const Languages = ({ getLang, data, isFromEditLanguage }) => {

    const dispatch = useDispatch();
    const { language } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
    const questions = data?.data?.MENTOR_BACKGROUND && data?.data?.MENTOR_BACKGROUND?.find((ele) => {
        return ele.sub_category_name === "ENGLISH_IS_NOT_YOUR_FIRST_LANGUAGE";
    });
    const location = useLocation();
    const mentorId = location?.state?.mentorId;
    const { savedAnswer, studentProfileIfo } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
    const { MENTOR_BACKGROUND } = mentorId ? studentProfileIfo : savedAnswer;
    
    const mentorBGData = !isEmpty(MENTOR_BACKGROUND) && MENTOR_BACKGROUND?.find(item => item.sub_category_name === 'ENGLISH_IS_NOT_YOUR_FIRST_LANGUAGE');
    const defaultvals = mentorBGData?.options && mentorBGData?.options?.map(option => option?.option_id)[0] || null;
    const defaultLang = mentorBGData?.master_data ? mentorBGData?.master_data : [];

    const [searchQuery, setSearchQuery] = useState('');
    const [optionSelected, setOptionSelected] = useState(defaultvals);
    const [selectedLanguage, setSelectedLanguage] = useState(defaultLang);

    const handleInputChange = (event, newInputValue) => {
        setSearchQuery(newInputValue);
        setTimeout(() => {
            dispatch(getLanguages(1, [], newInputValue))
        }, 200);
    };

    const loadMoreResults = () => {
        if (language?.pagination?.isNextPage) {
            dispatch(getLanguages(language?.pagination?.nextPage, language?.result))
        }
    }
    useEffect(() => {
        dispatch(getLanguages());
    }, []);

    useMemo(() => {
        getLang({ optionSelected, selectedLanguage })
    }, [optionSelected, selectedLanguage]);

    const handleDeleteChip = (chipToDelete) => {
        setSelectedLanguage((chips) => chips?.filter((chip) => chip?.id !== chipToDelete?.id));
      };
    return (
        <ThemeProvider theme={theme}>
            <Box>
                <Box variant="form">
                    {
                        !isFromEditLanguage &&
                        <Typography variant="h2">
                            {en?.GREAT_TEXT}
                        </Typography>
                    }
                    <OptionsWrapper>
                        <Typography variant="h3" sx={{ mb: 0 }}>{questions && questions?.question_text} <span style={{color: "#DC3545" }}>*</span></Typography>
                        <FormGroup sx={{ mt: 2 }}>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue=""
                                name="radio-buttons-group"
                            >
                                {questions && questions?.options?.map((option) => (
                                    <>
                                    <FormControlLabel
                                        key={option?.option_id}
                                        control={<Radio checked={option?.option_id === optionSelected}/>}
                                        value={option?.option_text?.toLowerCase()}
                                        label={option?.option_text}
                                        onClick={() => setOptionSelected(option?.option_id)}
                                    />
                                      {(option?.option_text === 'Yes') ?
                                      optionSelected === questions?.options?.find((e)=> e.option_text === 'Yes')?.option_id && (
                                        <>
                                        <Autocomplete
                                            multiple
                                            id="searchLanguage"
                                            options={language?.result || []}
                                            getOptionLabel={(option) => option?.language_name}
                                            onChange={(event, value) => checkDuplicateChipValue(value, selectedLanguage, setSelectedLanguage)}
                                            value={selectedLanguage}
                                            inputValue={searchQuery}
                                            onInputChange={handleInputChange}
                                            ListboxProps={{
                                                onScroll: (event) => {
                                                    const listboxNode = event.currentTarget;
                                                    if (Math.ceil(listboxNode.scrollTop) + listboxNode.clientHeight === listboxNode.scrollHeight) {
                                                        loadMoreResults()
                                                    }
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Search and add language"
                                                    variant="outlined"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SearchOutlinedIcon />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />
                                        <ChipWrapper>
                                        {selectedLanguage?.map((chip) => (
                                          <Chip
                                            key={chip?.id}
                                            label={chip?.language_name}
                                            onDelete={() => handleDeleteChip(chip)}
                                            deleteIcon={<CloseOutlinedIcon />}
                                          />
                                        ))}
                                      </ChipWrapper>
                                      </>
                                    ) : null}
                                    </>
                                ))}
                            </RadioGroup>
                        </FormGroup>
                    </OptionsWrapper>
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default Languages;
